import React, { useEffect } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { acceptInvitationCollaborationAction } from 'src/reducers/collection/action'
import styles from './styles'
import { set as setCookie } from 'es-cookie'
const AcceptInvitation = ({ classes }) => {
  const dispatch = useDispatch()
  const { code } = useParams()
  useEffect(() => {
    if (code) {
      dispatch(
        acceptInvitationCollaborationAction(code, () => {
          // delete redirectUrl
          setCookie('redirectUrl', '')
          window.location.href = '/collections/shared-collections'
        }),
      )
    }
  }, [code])
  return (
    <div className={classes.root}>
      <Typography>Redirecting...</Typography>
    </div>
  )
}

export default withStyles(styles)(AcceptInvitation)
